//Sunset Bliss
const sunshineBliss = [
    "rgba(135, 206, 235, 1)",  // Sky Blue
    "rgba(70, 130, 180, 1)",   // Steel Blue
    "rgba(0, 191, 255, 1)",    // Deep Sky Blue
    "rgba(30, 144, 255, 1)",   // Dodger Blue
    "rgba(100, 149, 237, 1)",  // Cornflower Blue
];

//Autumn Harvest
const autumnHarvest = [
    "rgba(255, 140, 0, 0.5)",   // Dark Orange
    "rgba(210, 105, 30, 0.5)",  // Chocolate
    "rgba(139, 69, 19, 0.5)",   // Saddle Brown
    "rgba(160, 82, 45, 0.5)",   // Sienna
    "rgba(205, 92, 92, 0.5)",   // Indian Red
];

//Spring Meadow
const springMeadow = [
    "rgba(0, 255, 127, 0.5)",   // Spring Green
    "rgba(127, 255, 0, 0.5)",   // Chartreuse
    "rgba(50, 205, 50, 0.5)",   // Lime Green
    "rgba(173, 255, 47, 0.5)",  // Green Yellow
    "rgba(152, 251, 152, 0.5)", // Pale Green
];

//Aurora Glow
const auroraGlow = [
    "rgba(138, 43, 226, 0.5)",  // Blue Violet
    "rgba(148, 0, 211, 0.5)",   // Dark Violet
    "rgba(153, 50, 204, 0.5)",  // Dark Orchid
    "rgba(186, 85, 211, 0.5)",  // Medium Orchid
    "rgba(147, 112, 219, 0.5)", // Medium Purple
];

//f44336 should be the first color in the errorPalette
const errorPalette = [
    "rgba(244, 67, 54, 1)",   // Red //f44336
    "rgb(175, 6, 6)",  // Dark Orange
    "rgba(255, 99, 71, 1)",  // Tomato
    "rgba(255, 165, 0, 1)",  // Orange
    "rgba(255, 215, 0, 1)",  // Gold
];

export { sunshineBliss, autumnHarvest, springMeadow, auroraGlow, errorPalette };